import { MonitorIcon, MoonIcon, SunIcon } from "lucide-react";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { useTheme, type Theme } from "@/components/theme-provider";

const OPTIONS: Array<{ value: Theme; label: "themeLight" | "themeDark" | "themeSystem"; icon: typeof SunIcon }> = [
  { value: "light", label: "themeLight", icon: SunIcon },
  { value: "dark", label: "themeDark", icon: MoonIcon },
  { value: "system", label: "themeSystem", icon: MonitorIcon },
];

export function ThemeToggle() {
  const { theme, resolved, setTheme } = useTheme();
  const { t } = useTranslation();
  const Icon = resolved === "dark" ? MoonIcon : SunIcon;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label={t("nav.changeTheme")}>
          <Icon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        {/* A radio group, so a screen reader says which theme is the current one. */}
        <DropdownMenuRadioGroup value={theme} onValueChange={(value) => setTheme(value as Theme)}>
          {OPTIONS.map((option) => (
            <DropdownMenuRadioItem
              key={option.value}
              value={option.value}
              data-active={theme === option.value || undefined}
              className="data-[active]:bg-accent"
            >
              <option.icon />
              {t(`nav.${option.label}`)}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
